function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMultipleSelection, useSelect } from "downshift";
export function isOptionEqualToValueDefault(option, value) {
  return option === value;
}
export function virtualizerEstimateHeightBySize(size) {
  return size === "sm" ? 36 : 48;
}
export function useSelectStateReducerForMultipleSelect(state, change) {
  switch (change.type) {
    // Workaround to https://github.com/downshift-js/downshift/issues/1554
    case useSelect.stateChangeTypes.ToggleButtonBlur:
      return _objectSpread(_objectSpread({}, change.changes), {}, {
        selectedItem: null
      });
    // Do not allow selection with character keys for multiple selection
    case useSelect.stateChangeTypes.ToggleButtonKeyDownCharacter:
      return state;
    // Do not close the menu after selection, in multiple mode
    case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
    case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
    case useSelect.stateChangeTypes.ItemClick:
      return _objectSpread(_objectSpread({}, change.changes), {}, {
        isOpen: true,
        highlightedIndex: state.highlightedIndex
      });
    default:
      return change.changes;
  }
}
export function useMultipleSelectionStateReducer(state, _ref) {
  let {
    type,
    changes
  } = _ref;
  switch (type) {
    case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownNavigationNext:
      // when reaching last item then arrow right, stop navigation.
      return _objectSpread(_objectSpread({}, changes), {}, {
        activeIndex: changes.activeIndex === -1 ? state.activeIndex : changes.activeIndex
      });
    case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownNavigationPrevious:
      // when reaching first item then arrow left, focus the Select.
      return _objectSpread(_objectSpread({}, changes), {}, {
        activeIndex: state.activeIndex === 0 ? -1 : changes.activeIndex
      });
    case useMultipleSelection.stateChangeTypes.DropdownKeyDownNavigationPrevious:
      // do nothing when hitting arrow left on Select.
      return state;
    case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
      return state;
    default:
      return changes;
  }
}